import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function MaintenanceTypeData(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            multiple
            id="bl_table_Autocomplete_12"
            options={props.maintenanceTypeData}
            //renderTags={() =>{}}
            limitTags={5}
            value={props.maintenanceTypeData.filter((item) => props.maintenanceType?.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField id="bl_table_TextField_12" {...params} margin="normal" label={t("MaintenanceType")} variant="outlined" size={props.size ?? "small"} />}
            onChange={(event, newValue) => {
                props.HandleMaintenanceType(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
            size={props.size ?? "normal"}
        />
    );
}
